/**
 * True when the hub is running inside a frame. Sign-in, development identity and "Accept invitation"
 * are one-click actions, so the hub refuses to run framed (clickjacking). Static hosting cannot always
 * send a frame-ancestors header, hence this check. Reading window.top from a cross-origin frame can
 * throw, which also means framed.
 */
export function isFramed(win: { readonly top: unknown; readonly self: unknown } = window): boolean {
  try {
    return win.top !== win.self;
  } catch {
    return true;
  }
}
